import React from 'react'
import styled, { css } from 'styled-components'
import { Helmet } from 'react-helmet'
import { Layout } from '../layout'

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  padding: 50px 0;
  margin: 0 auto;
  /*   color: var(--text); */
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`

const Tools = () => {
  return (
    <Layout>
      <Helmet>
        <title>Shopify Tools and Apps – Robert Eberhard</title>
      </Helmet>
      <SectionWrapper>
        <SectionContainer>Coming soon...</SectionContainer>
      </SectionWrapper>
    </Layout>
  )
}

export default Tools
